import React, { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'https://v-room.app/api').replace(/\/$/, '');

function blocks(content) {
  return String(content || '').split(/\n\s*\n+/).map((block) => block.trim()).filter(Boolean);
}

function renderBlock(block, index) {
  const lines = block.split('\n').map((line) => line.trim()).filter(Boolean);
  const heading = lines[0]?.startsWith('## ') ? lines.shift().slice(3).trim() : '';
  const list = lines.length > 0 && lines.every((line) => line.startsWith('- '));

  return (
    <section className="legal-section" key={`${heading || 'paragraph'}-${index}`}>
      {heading && <h3>{heading}</h3>}
      {list
        ? <ul>{lines.map((line, lineIndex) => <li key={`${line}-${lineIndex}`}>{line.slice(2)}</li>)}</ul>
        : lines.map((line, lineIndex) => <p key={`${line}-${lineIndex}`}>{line}</p>)}
    </section>
  );
}

export default function LegalDocument({ documentKey, fallbackTitle }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    Promise.all([
      fetch(`${API}/legal/documents/${documentKey}`).then((response) => response.ok ? response.json() : Promise.reject(new Error('Dokument nie został jeszcze opublikowany'))),
      fetch(`${API}/legal/entity`).then((response) => response.json()),
    ]).then(([document, entity]) => setData({ document: document.document, entity: entity.entity })).catch((requestError) => setError(requestError.message));
  }, [documentKey]);
  if (error) return <div className="legal-section"><h3>{fallbackTitle}</h3><p>{error}. Skontaktuj się z nami: <a href="mailto:kontakt.vroomapp@gmail.com">kontakt.vroomapp@gmail.com</a>.</p></div>;
  if (!data) return <p className="legal-date">Ładowanie aktualnej wersji dokumentu…</p>;
  const version = data.document.currentVersion;
  return <div className="legal-document-flow"><p className="legal-date">Wersja {version.version} · obowiązuje od {new Date(version.effectiveAt || version.publishedAt).toLocaleDateString('pl-PL')}</p>{version.summary && <p className="legal-lead">{version.summary}</p>}{blocks(version.content).map(renderBlock)}<section className="legal-section legal-company-data"><h3>Dane operatora</h3><p><strong>{data.entity.legalName}</strong><br />{data.entity.streetAddress}, {data.entity.postalCode} {data.entity.city}<br />KRS: {data.entity.krs} · NIP: {data.entity.nip} · REGON: {data.entity.regon}<br />Kapitał zakładowy: {(data.entity.shareCapital / 100).toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' })}<br />{data.entity.registryCourt}<br /><a href={`mailto:${data.entity.email}`}>{data.entity.email}</a></p></section></div>;
}
